import { useState, useEffect } from 'react';
import { StaticValues } from '../../../../../insfrastructure/services/static_values';
import { GenderOptions, SegmentOption } from '../types';

export const useGenderOptions = (): GenderOptions => {
  const [genderOptions, setGenderOptions] = useState<GenderOptions>({});

  useEffect(() => {
    try {
      const staticValues = JSON.parse(localStorage.getItem('static_values') || '{}') as StaticValues;
      if (staticValues.gender) {
        setGenderOptions(staticValues.gender as GenderOptions);
      }
    } catch (error) {
      console.error('Erro ao carregar opções de gênero:', error);
    }
  }, []);

  return genderOptions;
};

export const useSegmentOptions = (): SegmentOption[] => {
  const [segmentOptions, setSegmentOptions] = useState<SegmentOption[]>([]);

  useEffect(() => {
    try {
      const staticValues = JSON.parse(localStorage.getItem('static_values') || '{}') as StaticValues;
      if (staticValues.segment) {
        const options = Object.keys(staticValues.segment)
          .map((key: string) => ({ value: key, label: staticValues.segment[key] }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setSegmentOptions(options);
      }
    } catch (error) {
      console.error('Erro ao carregar opções de segmento:', error);
    }
  }, []);

  return segmentOptions;
};

